import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import LoginForm from '../../../../components/forms/LoginForm/index'
import { login } from '../../../../state/redux/actions/authActions'
import { unwrapResult } from '@reduxjs/toolkit'

const Login = () => {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleSubmit = async credentials => {
    try {
      setError('')
      setLoading(true)
      const userLogin = await dispatch(login(credentials))
      unwrapResult(userLogin)
      navigate('/dashboard')
      setLoading(false)
    } catch (error) {
      setError(error.message || 'Invalid email or password')
      console.error('Login failed:', error)
      setLoading(false)
    }
  }

  return (
    <div className="flex justify-center items-center w-screen h-screen px-4 sm:px-6">
      <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow w-full max-w-[95vw] sm:max-w-md md:max-w-lg">
        <div className="flex justify-center mb-4 sm:mb-6">
          <img
            src="/assets/images/swapspace-new-logo3.png"
            alt="SwapSpace Logo"
            className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 object-contain"
          />
        </div>
        <LoginForm onSubmit={handleSubmit} loading={loading} error={error} />
      </div>
    </div>
  )
}

export default Login
